import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import isEmpty from 'lodash/fp/isEmpty';
import { pure } from '@dbk-legacy/ui-react-utils';
import { BasicNumber } from '@dbk/ui-numbers';
import { IntlProvider } from '@dbk/format';
import { StyleSheet } from 'react-native';
// import Text, { Large } from '../../../../../../../src/components/common/text';
import Text,{H4} from '@dbk/ui-text';
import TableRow from '../../../../../../../src/components/common/table-row';
import {
  SimpleNumber,
  Currency,
} from '../../../../../../../src/components/common/number';

import styles from './position-header.styles';

function PositionHeader(props) {
  const { labels = {}, position = {}, messages, langCode } = props;
  const quantityArr = position.quantity && position.quantity.toString().split('.');
  const minDecimalReq = (quantityArr && quantityArr.length > 1) ? quantityArr[1].length : 2;

  if (isEmpty(position)) {
    return <View><Text>loading</Text></View>;
  }


  return (
    <View style={styles.container} testID="position-header">
      <div tabIndex={0} className="heading-for-asset-transactions">
      <H4 testID="position-header-label" className="margin-top-1 margin-bottom-10">
        {position.securityName}
      </H4>
      </div>
      <div tabIndex={0} className="pad-top-20">
        <TableRow>
          <TableRow.Column
            align="left"
            testID="position-header-item-label"
          >
            <Text size="big" secondary testID="position-header-item-label">{messages[labels.quantity]}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
          >
            {/* <SimpleNumber
              minimumFractionDigits={0}
              maximumFractionDigits={2}
              renderProps={{
                testID: 'position-header-item-value',
              }}
              value={position.quantity}
            /> */}

            <IntlProvider locale={langCode}>
              <BasicNumber
                value={position.quantity}
                minimumFractionDigits={minDecimalReq}
                renderProps={{
                  className:'big',
                  testID: 'position-header-item-value',
                }}
              />
            </IntlProvider>
          </TableRow.Column>
        </TableRow>
      </div>
      <div tabIndex={0}>
        <TableRow>
          <TableRow.Column
            align="left"
            testID="position-header-item-label"
          >
            <Text size="big" secondary testID="position-header-item-label">{messages[labels.marketValue]}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
          >
            <Currency
              value={position.marketValue}
              currency={StyleSheet.flatten(position.marketValueUnit)}
              currencyStyle={styles.value}
              renderProps={{
                style: styles.value,
                size: 'big',
                testID: 'position-header-item-value',
              }}
            />
          </TableRow.Column>
        </TableRow>
      </div>
      <div tabIndex={0}>
        <TableRow>
          <TableRow.Column
            align="left"
            testID="position-header-item-label"
          >
            <div aria-label={messages['app.assets.unrealisedGain/Loss']}>
            <Text size="big" secondary
              testID="position-header-item-label"
            >{messages[labels.unrealisedGL]}</Text>
            </div>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
          >
            <Text testID="position-header-item-value">
              <Currency
                value={position.unrealisedGL}
                currency={position.unrealisedGLUnit}
                currencyStyle={StyleSheet.flatten(styles.value)}
                renderProps={{
                  size: 'big',
                  style: styles.value,
                }}
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </div>
    </View>
  );
}

PositionHeader.propTypes = {
  position: PropTypes.shape({
    securityName: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    marketValue: PropTypes.number,
    marketValueUnit: PropTypes.string,
    unrealisedGL: PropTypes.number.isRequired,
    unrealisedGLUnit: PropTypes.string.isRequired,
    unrealisedGLPercentage: PropTypes.number.isRequired,
  }),
  labels: PropTypes.shape({
    quantity: PropTypes.string.isRequired,
    marketValue: PropTypes.string.isRequired,
    unrealisedGL: PropTypes.string.isRequired,
  }),
};

export default pure(PositionHeader);
